import { isNestedTypeProperty, sortPropertyByTypeElementDeveloperName } from '../../sources/type';
import type { TypeElementResponseAPI, TypeMappingAutoAPI } from '../../types/type';
import PropertyDetails from './PropertyDetails';

type Types = Record<string, TypeElementResponseAPI>;

interface Props {
    sourceTypeElementId: string;
    targetTypeElementId: string | null | undefined;
    types: Types;
    mapping: TypeMappingAutoAPI | null | undefined;
    visitedTypeElementIds?: Set<string>;
}

const AutoMappingTypeMatched = ({
    sourceTypeElementId,
    targetTypeElementId,
    types,
    mapping,
    visitedTypeElementIds,
}: Props) => {
    const sourceType = types[sourceTypeElementId];
    const targetType = targetTypeElementId ? types[targetTypeElementId] : null;
    // Track types already on this branch to avoid infinite recursion on cyclic types.
    const nextVisited = new Set(visitedTypeElementIds).add(sourceTypeElementId);

    return (
        <ol key={sourceType.id}>
            {sourceType.properties.sort(sortPropertyByTypeElementDeveloperName).map((property) => {
                const mappedProperty = mapping?.properties.find(
                    (p) => p.sourceTypeElementEntryId === property.id,
                );
                const targetProperty =
                    mappedProperty && targetType
                        ? targetType.properties.find(
                              (p) => p.id === mappedProperty.targetTypeElementEntryId,
                          )
                        : null;

                return (
                    <li key={property.id}>
                        {targetProperty ? (
                            <PropertyDetails
                                property={targetProperty}
                                types={types}
                                isMatched={false}
                                showMatch={false}
                            />
                        ) : (
                            <p className="property-details" />
                        )}
                        {isNestedTypeProperty(property) &&
                        !nextVisited.has(property.typeElementId) ? (
                            <AutoMappingTypeMatched
                                sourceTypeElementId={property.typeElementId}
                                targetTypeElementId={mappedProperty?.children?.targetTypeElementId}
                                types={types}
                                mapping={mappedProperty?.children}
                                visitedTypeElementIds={nextVisited}
                            />
                        ) : null}
                    </li>
                );
            })}
        </ol>
    );
};

export default AutoMappingTypeMatched;
